// import { SuggestionType } from './SuggestionsExtension'

// interface MockAIResponse {
//   text: string
//   confidence: number
//   signal: AbortSignal
// }

// type MockAPIComplete = (context: string, type: SuggestionType | null, signal?: AbortSignal) => Promise<string>

// export const mockAIComplete: MockAPIComplete = async (context, type, signal?: AbortSignal) => {
//   const completions: Record<SuggestionType, string[]> = {
//     sentenceCompletion: [
//       'This leads to significant improvements in efficiency',
//       'Which creates new opportunities for innovation',
//     ],
//     listExpansion: [
//       '\n- Improved efficiency and productivity\n- Better resource utilization',
//       '\n- Reduced operational costs\n- Increased customer satisfaction',
//     ],
//     elaboration: [
//       'the implementation of machine learning algorithms',
//       'the integration of automated testing frameworks',
//     ],
//     summary: [
//       'these factors contribute to a more robust solution',
//       'this approach provides significant advantages',
//     ],
//     transition: [
//       'this presents an interesting opportunity',
//       'we must consider the alternatives',
//     ],
//   }

//   const defaultCompletions = [
//     'continues to evolve and improve',
//     'shows promising results',
//   ]

//   const relevantCompletions = type ? completions[type] || defaultCompletions : defaultCompletions

//   return new Promise<string>((resolve, reject) => {
//     const timeout = setTimeout(() => {
//       resolve(relevantCompletions[Math.floor(Math.random() * relevantCompletions.length)])
//     }, 500)

//     if (signal) {
//       signal.addEventListener('abort', () => {
//         clearTimeout(timeout)
//         reject(new Error('Mock AI completion aborted'))
//       })
//     }
//   })
// }

import { SuggestionType } from './SuggestionsExtension';

type APIComplete = (
  context: string,
  type: SuggestionType | null,
  signal?: AbortSignal
) => Promise<string>;

export const realAIComplete: APIComplete = async (context, type, signal) => {
  const systemPrompt = `
    You are an advanced, helpful assistant focused on providing text completions directly related to the user's input. Avoid generating unnecessary prefixes or filler content, and only respond with relevant information that extends the input meaningfully. Ensure responses are clear, accurate, and formatted in Markdown when appropriate, with no unnecessary introductory symbols or ellipses.
  `;

  const response = await fetch("https://api.deepinfra.com/v1/openai/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer vQuuhWcgnwWEkXmEwEKUZLsJgKTZlXEs`,
    },
    body: JSON.stringify({
      model: "meta-llama/Meta-Llama-3.1-70B-Instruct",
      max_tokens: 30,
      messages: [
        {
          role: "system",
          content: systemPrompt,
        },
        {
          role: "user",
          content: context,
        },
      ],
    }),
    signal, 
  });

  if (!response.ok) {
    throw new Error("Failed to fetch AI completion.");
  }

  const data = await response.json();
  const completion = data.choices?.[0]?.message?.content;

  if (!completion) {
    throw new Error("No completion received from AI.");
  }

  return completion;
};
